module.exports = __webpack_public_path__ + "static/media/audi_zertifikat_2014.c217d843.jpg";